import { call, put, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { changePassword } from '../../services/authService';
import {
  changePasswordRequest,
  changePasswordSuccess,
  changePasswordFailure,
  logout,
} from '../reducers/authReducer';

function* handleChangePassword(action) {
  try {
    const { currentPassword, newPassword, confirmPassword } = action.payload;
    const response = yield call(changePassword, currentPassword, newPassword, confirmPassword);

    if (response.success) {
      yield put(changePasswordSuccess());
      yield put(logout());
      // Show success message
      toast.success(response.message);
      // Redirect to login page
      window.location.href = '/login';
      toast.success(response.message);
    } else {
      yield put(changePasswordFailure(response.message));
      toast.error(response.message);
    }
  } catch (error) {
    yield put(changePasswordFailure(error.message));
    toast.error('An error occurred while changing the password.');
  }
}

export default function* authSaga() {
  yield takeEvery(changePasswordRequest.type, handleChangePassword);
}